import React, { useState, useEffect } from 'react';
import PlanServices from '../../services/PlanServices';
import { useNavigate } from 'react-router-dom';
import { ThemeToggle } from '../../components/ThemeToggle';
import './Pricing.css';
function Pricing() {
  const [planData, setPlanData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPlan = async () => {
      try {
        const response = await PlanServices.getAllPlan();
        console.log(response);
        setPlanData(response?.data || []);
      } catch (error) {
        console.error('Failed to fetch plans:', error);
      }
    };
    fetchPlan();
  }, []);
const handleSubscribe = async (plan) => {
  try {
    // Step 1: Call backend to create Razorpay Order
    const response = await PlanServices.createSubscriptionByUser({ planId: plan._id });
    console.log('Order API response:', response);

    const data = response?.data;

    if (!data || !data.id) {
      throw new Error('Invalid Razorpay order response');
    }

    const razorpayOrderId = data.id;
    const amount = data.amount;

    // Step 2: Configure Razorpay options
    const options = {
      key: 'rzp_test_oVUaqVOJuonfo8',
      amount: amount,
      currency: 'INR',
      name: 'Option Trading Wala',
      description: `Subscription for ${plan.name} Plan`,
      image: 'https://your-logo-url.com/logo.png',
      order_id: razorpayOrderId,
      handler: async function (paymentResponse) {
        try {
          const verifyResponse = await PlanServices.verifySubscription({
            razorpay_order_id: razorpayOrderId,
            razorpay_payment_id: paymentResponse.razorpay_payment_id,
            razorpay_signature: paymentResponse.razorpay_signature,
            planId: plan._id
          });

          if (verifyResponse.status === true) {
            alert('Subscription successful!');
            navigate('/pricing');
          } else {
            alert('Payment verification failed.');
          }
        } catch (err) {
          console.error('Verification error:', err);
          alert('Error verifying payment.');
        }
      },
      theme: {
        color: '#3399cc'
      }
    };

    if (!window.Razorpay) {
      await new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://checkout.razorpay.com/v1/checkout.js';
        script.onload = resolve;
        script.onerror = () => reject(new Error('Failed to load payment gateway'));
        document.body.appendChild(script);
      });
    }
    const rzp = new window.Razorpay(options);
    rzp.open();
  } catch (err) {
    console.error('Subscription creation error:', err);
    alert(err.message || 'Failed to initiate subscription.');
  }
};
  // Plan with the lowest price per day gets the "Best value" badge.
  const perDay = (plan) => (Number(plan.validity) > 0 ? Number(plan.price) / Number(plan.validity) : Infinity);
  const bestValueId = planData.length > 1
    ? planData.reduce((best, plan) => (perDay(plan) < perDay(best) ? plan : best), planData[0])?._id
    : null;

  return (
    <div className="pp-page">
      {/* Own top bar (this page has no site header): sidebar toggle, logo, theme */}
      <div className="pp-topbar">
        <div className="toggle-btn-outer pp-menu">
          <button type="button" aria-label="Open menu">
            <i className="fa fa-bars" />
          </button>
        </div>
        <a href="/" className="pp-logo"><img src="img/header-logo.svg" alt="Option Trading Wala" /></a>
        <ThemeToggle className="shrink-0" />
      </div>

      <section className="pp-hero">
        <span className="pp-eyebrow">Plans &amp; Pricing</span>
        <h1>Welcome to Option Trading Wala (OTW)</h1>
        <p>Please select a plan to continue. All prices include GST (18%).</p>
      </section>

      <section className="pp-grid">
        {planData.map((plan, index) => {
          const best = plan._id && plan._id === bestValueId;
          const daily = perDay(plan);
          return (
            <article key={plan._id || index} className={`pp-card${best ? ' pp-card--best' : ''}`}>
              {best && <span className="pp-badge">Best value</span>}
              <h2 className="pp-plan">{`OTW ${String(plan.name || '').toUpperCase()} PLAN`}</h2>
              <div className="pp-price">
                <span className="pp-currency">₹</span>
                <span className="pp-amount">{plan.price}</span>
              </div>
              <p className="pp-validity">
                For {plan.validity} days · incl. GST (18%)
                {Number.isFinite(daily) && <><br /><span className="pp-daily">≈ ₹{daily.toFixed(0)} / day</span></>}
              </p>
              <ul className="pp-features">
                {(plan.description || []).map((desc, i) => (
                  <li key={i}><i className="fa fa-check-circle" aria-hidden="true" />{desc}</li>
                ))}
              </ul>
              <button type="button" className="pp-subscribe" onClick={() => handleSubscribe(plan)}>
                Subscribe
              </button>
            </article>
          );
        })}
        {planData.length === 0 && <p className="pp-empty">No plans available.</p>}
      </section>

      <footer className="pp-links">
        <a href="privacy-policy">Privacy Policy</a>
        <a href="term-and-services">Terms of Services</a>
        <a href="cancelpolicy">Cancellation &amp; Refund Policy</a>
      </footer>
    </div>
  );
}

export default Pricing;
